export { default } from './TablePagination';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TablePagination/index.js
// module id = 856
// module chunks = 2